<template>
  <div class="section-item">
    <icon name="check-circle" class="check-icon" />
    <span class="section-item-name">{{ itemName }} </span>
  </div>
</template>
<script>
export default {
  props: {
    itemName: { type: String, default: null }
  }
};
</script>
<style scoped>
.check-icon {
  width: 1.1rem;
  margin-right: 0.5rem;
}

.section-item {
  margin-top: 1rem;
}

.section-item-name {
  vertical-align: top;
}
</style>
